import { FieldDefinition } from "./fieldDefinitions";

export interface MedicineDoseDto {
  doseId: number;
  hours?: string;
  days?: string;
  dateUpdated?: string;
  userId: number;
}

export const medicinedoseKeyId = "doseId" as const;

export const medicineDoseFields: FieldDefinition[] = [
  { name: "hours", label: "Ώρες", type: "text", required: false },
  { name: "days", label: "Ημέρες", type: "text", required: false },
  {
    name: "dateUpdated",
    label: "Ημερομηνία Ενημέρωσης",
    type: "date",
    required: false,
  },
  { name: "userId", label: "ID Χρήστη", type: "number", required: true },
] as const;

export const medicineDoseFormData: string[] = ["hours", "days"];
